import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Adjust the import path as needed

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();

  // If user is not authenticated, redirect to login page
  if (!auth) {
    return <Navigate to="/login" />
  }

  // If authenticated, render the children components
  return children;
};

export default ProtectedRoute;
